/* CERISSO hareket sistemi — tek dosya.
   prefers-reduced-motion: reduce -> hicbir animasyon yok, icerik aninda gorunur.
   Icerir: Lenis akici kaydirma (H), acilis (A), sirali giris (B),
   scroll reveal (C), parallax masaustu (D), mobil acilis (E), imza cizgisi (G).
   Sepete-ekle (F) ve menu cizgisi (I) saf CSS'tedir. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- H) Lenis akici kaydirma (mobilde de aktif, hafif lerp) ---- */
  if (!reduce && typeof window.Lenis === 'function') {
    try {
      var lenis = new window.Lenis({ lerp: 0.1, smoothWheel: true, wheelMultiplier: 1 });
      var rafLenis = function (t) { lenis.raf(t); requestAnimationFrame(rafLenis); };
      requestAnimationFrame(rafLenis);
      window.__cerissoLenis = lenis;
    } catch (e) { /* Lenis baslayamadi: normal kaydirma devam eder */ }
  }

  /* Hareket kapaliysa: animasyon yok, icerik gorunur (CSS .cerisso-motion eklenmez) */
  if (reduce) return;

  document.documentElement.classList.add('cerisso-motion');

  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  onReady(function () {
    /* ---- A + B + E) Acilis ve sirali giris ---- */
    var entryEls = document.querySelectorAll('.ca-open, .ca-anim');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        for (var i = 0; i < entryEls.length; i++) entryEls[i].classList.add('is-in');
      });
    });

    /* ---- C + E) Scroll reveal (her oge bir kez) ---- */
    var revealEls = document.querySelectorAll('[data-cerisso-reveal]');
    if ('IntersectionObserver' in window && revealEls.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });
      for (var r = 0; r < revealEls.length; r++) io.observe(revealEls[r]);
    } else {
      for (var r2 = 0; r2 < revealEls.length; r2++) revealEls[r2].classList.add('is-in');
    }

    /* ---- D) Parallax — yalnizca masaustu (>=769px) ---- */
    var parallaxEls = document.querySelectorAll('[data-cerisso-parallax], .banner .banner__media');
    var mqDesktop = window.matchMedia('(min-width: 769px)');
    var pTick = false;

    function updateParallax() {
      pTick = false;
      if (!mqDesktop.matches) return;
      for (var i = 0; i < parallaxEls.length; i++) {
        var el = parallaxEls[i];
        var rect = el.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) continue;
        var off = (rect.top * -0.12).toFixed(1);
        el.style.transform = 'translateY(' + off + 'px) scale(1.08)';
      }
    }
    function clearParallax() {
      for (var i = 0; i < parallaxEls.length; i++) parallaxEls[i].style.transform = '';
    }
    function onScrollParallax() {
      if (pTick) return;
      pTick = true;
      requestAnimationFrame(updateParallax);
    }
    function setupParallax() { if (mqDesktop.matches) updateParallax(); else clearParallax(); }

    if (parallaxEls.length) {
      window.addEventListener('scroll', onScrollParallax, { passive: true });
      window.addEventListener('resize', setupParallax);
      if (mqDesktop.addEventListener) mqDesktop.addEventListener('change', setupParallax);
      setupParallax();
    }

    /* ---- G) Kiraz imza cizgisi — sayfa ilerlemesiyle scaleY ---- */
    var thread = document.querySelector('[data-cerisso-thread]');
    if (thread) {
      var tTick = false;
      function updateThread() {
        tTick = false;
        var h = document.documentElement.scrollHeight - window.innerHeight;
        var p = h > 0 ? Math.min(1, Math.max(0, window.pageYOffset / h)) : 1;
        thread.style.transform = 'scaleY(' + p.toFixed(3) + ')';
      }
      window.addEventListener('scroll', function () {
        if (tTick) return;
        tTick = true;
        requestAnimationFrame(updateThread);
      }, { passive: true });
      window.addEventListener('resize', updateThread);
      updateThread();
    }
  });
})();
